import _ from 'lodash';
import AccountNumberAndSortCodeFormValidation from './AccountNumberAndSortCodeFormValidation';
import IBANFormValidation from './IBANFormValidation';
import { getCountry } from '../../../../../iwIntlProvider/CountryProvider';

export type fieldValues = {
    sortCode: string;
    accountNumber: string;
    iban: string;
};

export const validateBankDetails = (fieldValues: fieldValues) => {
    if (_.includes(['DE'], getCountry())) {
        return IBANFormValidation(fieldValues);
    } else {
        return AccountNumberAndSortCodeFormValidation(fieldValues);
    }
};
